// extracted by mini-css-extract-plugin
export default {"container":"SettingsPage_container__96Fud","aside":"SettingsPage_aside__qFeyQ","main":"SettingsPage_main__WXfEO","wrapper":"SettingsPage_wrapper__zYa3z"};